import { ReactNode } from 'react'
import styled from 'styled-components'
type Props = {
    children: ReactNode;
}

const Main = styled.main`
    background-color: #efefef;
    position: relative;
    min-height: 25vh;
    font-family: 'Poppins', 'Lucida Sans', sans-serif;
    .about {
        text-align: justify;
        font-size: 18px;
    }

    .loader-container {
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`

const Content = ({children} : Props) => {
    return(
        <Main className='px-2 py-4 px-md-4 px-lg-5'>
            {children}
        </Main>
    )
}

export default Content;